import React from "react";
import cn from "classnames";
import {createUseStyles} from "react-jss";
import {brandColor} from "~/theme";
import PropTypes from "prop-types";

export default function UILink({tagName: Tag, href, className, ...props}) {
  const classes = useStyles();

  return (
    <Tag
      className={cn(classes.root, className)}
      href={href}
      {...props}
    />
  )
}

UILink.defaultProps = {
  tagName: 'a',
};

UILink.propTypes = {
  tagName: PropTypes.any,
  href: PropTypes.string.isRequired,
};


const useStyles = createUseStyles({
  root: {
    color: brandColor,
    textDecoration: 'none',
    transition: [['color', '0.15s', 'ease']],
    borderBottom: [[1, 'solid', 'transparent']],
    cursor: 'pointer',
    outline: 'none',

    '&:hover, &:focus': {
      borderBottomColor: brandColor,
      textDecoration: 'none',
    },
  },

});

